// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"973cd1a4","453":"1c3f5155","455":"d011a4a2"}[chunkId] + ".chunk.js";
};